export function authInterceptor (config) {
  config.headers['x-csrf'] = 1
  return config
}
